import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import Search from "../../components/form/Search";
import Button from "../../components/form/Button";
import Table from "../../components/elements/table/Table";
import { setTitle } from "../../helpers/MetaTag";
import { decodeId, encodeId, handleFilterChange } from "../../helpers";

import {
  scholarshipAppDelete,
  scholarshipApplicationDetails,
  scholarshipApplicationList,
  scholarshipList,
} from "../../services/scholarshipService";
import dayjs from "dayjs";
import useFetch from "../../hooks/useFetch";
import { useDebounce } from "../../hooks/useDebounce";
import LimitSelect from "../../components/elements/LimitSelect";
import useMutation from "../../hooks/useMutation";
import { useNavigate, useParams } from "react-router-dom";
import ScholarshipMessageModal from "../../components/sections/admin/scholarship/modals/ScholarshipMessageModal";
import { creatChatList } from "../../services/communicationService";
import Lottie from "lottie-react";
import createAnimation from "../../assets/lottie/create.json";
import ScholarshipStatusModal from "../../components/sections/admin/scholarship/modals/ManageStatusModal";
import ReminderModal from "../../components/sections/admin/scholarship/modals/ReminderModal";
import { useSelector } from "react-redux";
import Tooltip from "../../components/elements/Tooltip";
import { useGetPermission } from "../../hooks/useGetPermission";
import DeleteModal from "../../components/common/DeleteModal";
import Badge from "../../components/elements/Badge";

const ScholarshipView = () => {
  setTitle("Vpeters Admin | Scholarship Application");
  const { permission, status } = useGetPermission("scholarshipApp");
  const { permission: scholarshipPermission, status: scholarshipStatus } =
    useGetPermission("scholarships");
  const params = useParams();
  const id = decodeId(atob(params?.id || ""));
  const { session } = useSelector((state) => state?.authProvider);
  const [modalOpen, setModalOpen] = useState({ isOpen: false, data: null });
  const [statusModalOpen, setStatusModalOpen] = useState({
    isOpen: false,
    data: null,
  });
  const [selectedItems, setSelectedItems] = useState([]);
  const [keyword, setKeyword] = useState("");
  const [isModelOpen, setIsModalOpen] = useState({
    reminder: false,
    data: null,
  });
  const search = useDebounce(keyword, 300);
  const navigate = useNavigate();

  const [filters, setFilters] = useState({
    limit: 10,
    page: 1,
    sortQuery: "-createdAt",
  });

  const [scholarshipKeyword, setscholarshipKeyword] = useState("");
  const scholarshipSearch = useDebounce(scholarshipKeyword, 300);
  const [deleteModal, setDeleteModal] = useState({
    isOpen: false,
    data: null,
  });
  const [scholarshipFilters] = useState({
    limit: 30,
    page: 1,
    sortQuery: "-createdAt",
  });

  const { data, error, isLoading, updateData, isFetching, refetch } = useFetch({
    dependencies: [
      "scholarshipView",
      permission?.list,
      filters,
      search,
      id,
      scholarshipPermission?.assignScholarship,
    ],
    fetchFunction: async () => {
      const scholarshipId = {};
      if (
        filters?.scholarshipId &&
        Array.isArray(filters?.scholarshipId) &&
        filters?.scholarshipId?.length > 0
      ) {
        filters?.scholarshipId?.forEach((item, i) => {
          scholarshipId[`scholarshipId[${i}]`] = item;
        });
      } else {
        [...(scholarshipPermission?.assignScholarship || [])]?.forEach(
          (item, i) => {
            scholarshipId[`scholarshipId[${i}]`] = item;
          }
        );
      }
      delete filters?.scholarshipId;

      const res = await scholarshipApplicationList({
        ...filters,
        ...(search && { keyword: search }),
        ...(id ? { "scholarshipId[0]": [id] } : scholarshipId),
      });
      if (res?.status !== 200) {
        toast.warning(res?.message);
      }
      return res?.docs;
    },
    enabled: !!permission?.list && status === "ok",
  });

  const {
    data: scholarshipData,
    error: scholarshipError,
    isLoading: scholarshipLoading,
  } = useFetch({
    dependencies: [
      "scholarshipList",
      scholarshipFilters,
      scholarshipSearch,
      scholarshipPermission?.list,
      scholarshipPermission?.assignScholarship,
    ],
    fetchFunction: async () => {
      const res = await scholarshipList({
        ...scholarshipFilters,
        ...(scholarshipSearch && { keyword: scholarshipSearch }),
      });

      return {
        ...res?.docs,
        data:
          scholarshipPermission?.assignScholarship?.length > 0
            ? res?.docs?.data?.filter((item) =>
                scholarshipPermission?.assignScholarship.includes(item?._id)
              )
            : res?.docs?.data,
      };
    },
    enabled: !!scholarshipPermission?.list && scholarshipStatus === "ok",
  });

  const tableHeadData = [
    {
      _id: 1,
      name: "Applicant Name",
      align: "left",
    },

    {
      _id: 2,
      name: "Email",
      align: "left",
    },

    {
      _id: 3,
      name: "Phone",
      align: "left",
    },
    {
      _id: 4,
      name: "Submission Date",
      align: "left",
    },
    {
      _id: 5,
      name: "Deadline",
      align: "left",
    },
    {
      _id: 6,
      name: "Scholarship Name",
      align: "left",
      isFilter: !id,
      isFilterSearch: true,
      filterSearch: (e) => {
        setscholarshipKeyword(e);
      },
      onFilter: (val) => {
        if (val?.length > 0) {
          setFilters((pre) => ({
            ...pre,
            scholarshipId: val?.map((item) => item?.value),
          }));
        } else {
          setFilters((pre) => {
            delete pre?.scholarshipId;
            return { ...pre };
          });
        }
      },
      filterData: scholarshipPermission?.list
        ? (scholarshipData?.data || [])?.map((item) => ({
            value: item?._id,
            name: item?.title,
            type: "checkbox",
          }))
        : [],
    },
    {
      _id: "applicationNumber",
      name: "Application Number",
      align: "left",
    },
    {
      _id: 7,
      name: "IP Address",
      align: "left",
    },
    {
      _id: 8,
      name: "Status",
      align: "left",
    },
    {
      _id: 9,
      name: "Status Comment",
      align: "left",
    },
    {
      _id: 10,
      name: "Message",
      align: "left",
    },
    {
      _id: 11,
      name: "Reminder",
      align: "left",
    },
    ...(data?.data.some((item) => item?.chatDetails?._id) || permission?.details
      ? [
          {
            _id: 12,
            name: "Action",
            align: "left",
          },
        ]
      : []),
  ];

  const statusStyles = {
    Received_Under_Review: {
      base: "!bg-blue-100 !border-blue-100 !text-blue-700",
      hover: "hover:!bg-blue-200 hover:!border-blue-200",
    },
    Additional_Action_Required: {
      base: "!bg-yellow-100 !border-yellow-100 !text-yellow-700",
      hover: "hover:!bg-yellow-200 hover:!border-yellow-200",
    },
    Interview_Stage: {
      base: "!bg-cyan-100 !border-cyan-100 !text-cyan-700",
      hover: "hover:!bg-cyan-200 hover:!border-cyan-200",
    },
    Awarded: {
      base: "!bg-green-100 !border-green-100 !text-green-700",
      hover: "hover:!bg-green-200 hover:!border-green-200",
    },
    Draft: {
      base: "!bg-purple-100 !border-purple-100 !text-purple-700",
      hover: "hover:!bg-purple-200 hover:!border-purple-200",
    },
    Not_Selected: {
      base: "!bg-red-100 !border-red-100 !text-red-700",
      hover: "hover:!bg-red-200 hover:!border-red-200",
    },
  };

  // Table Body Data =====================>
  const tableData = data?.data?.map((item) => {
    const currentStatus = item?.statusDetails?.title;
    const { base, hover } = statusStyles[currentStatus] || {
      base: "!bg-gray-100 !border-gray-100 !text-gray-700",
      hover: "hover:!bg-gray-200 hover:!border-gray-200",
    };
    console.log(item);
    return {
      _id: item?._id,
      rowData: [
        {
          _id: 1,
          type: "text",
          align: "left",
          cellClass: "!min-w-[100px]",
          data:
            item?.userDetails?.firstName + " " + item?.userDetails?.lastName ||
            "-",
          isTooltip: false,
        },
        {
          _id: 2,
          type: "text",
          align: "left",
          cellClass: "!min-w-[100px]",
          data: item?.userDetails?.email || "-",
        },
        {
          _id: 3,
          type: "text",
          align: "left",
          cellClass: "!min-w-[100px]",
          data: item?.userDetails?.phone || "-",
        },
        {
          _id: 4,
          type: "text",
          align: "left",
          cellClass: "!min-w-[100px]",
          data: item?.createdAt
            ? dayjs(item?.createdAt).format("DD MMM, YYYY")
            : "-",
        },
        {
          _id: 5,
          type: "text",
          align: "center",
          cellClass: "!min-w-[100px]",
          data: item?.deadLineStatus ? (
            <Badge
              label={item?.deadLineStatus}
              type={item?.deadLineStatus === "closed" ? "danger" : "success"}
            />
          ) : (
            "N/A"
          ),
        },
        {
          _id: 6,
          type: "text",
          align: "left",
          cellClass: "!min-w-[100px]",
          data: item?.scholarshipDetails?.title || "-",
        },
        {
          _id: "applicationNumber",
          type: "text",
          align: "left",
          cellClass: "!min-w-[100px]",
          data: item?.applicationNumber || "-",
        },
        {
          _id: 7,
          type: "text",
          align: "left",
          cellClass: "!min-w-[100px]",
          data: (
            <div>
              <h4>{item?.ipDetails || "-"}</h4>
              <h4>{item?.ipCountry || "-"}</h4>
            </div>
          ),
        },
        {
          _id: 8,
          type: "text",
          align: "left",
          cellClass: "!min-w-[100px]",
          data: (
            <>
              <Tooltip
                position="top"
                messageClass="max-w-52"
                message={item?.comment}
              >
                <Button
                  buttonClasses={`!h-10 ${base} ${hover} border rounded-md transition-all duration-200 ${
                    !["Awarded", "Not_Selected"].includes(currentStatus) &&
                    permission?.changeStatus
                      ? "!cursor-pointer"
                      : "!cursor-default"
                  }`}
                  buttonLabel={currentStatus?.replace(/_/g, " ") || "-"}
                  buttonLabelClasses={`font-medium !text-sm`}
                  buttonFunction={() =>
                    !["Awarded", "Not_Selected"].includes(currentStatus) &&
                    permission?.changeStatus
                      ? setStatusModalOpen({ isOpen: true, data: item })
                      : null
                  }
                />
              </Tooltip>
            </>
          ),
        },
        {
          _id: 9,
          type: "text",
          align: "left",
          cellClass: "!min-w-[100px]",
          data: item?.statusDetails?.description
            ? item?.statusDetails?.description.length > 25
              ? item?.statusDetails?.description.slice(0, 25) + "..."
              : item?.statusDetails?.description
            : "-",
        },
        {
          _id: 10,
          type: "text",
          align: "left",
          cellClass: "!min-w-[100px]",
          data: (
            <button
              type="button"
              onClick={() => {
                chatCreateHandler(item);
              }}
              className="text-chestnut-rose"
            >
              Send Message
            </button>
          ),
        },
        {
          _id: 11,
          type: "text",
          align: "left",
          cellClass: "!min-w-[100px]",
          data: (
            <span
              className={`text-red-600 transition-all duration-300 ${
                item?.statusDetails?.title !== "Draft"
                  ? "opacity-50 cursor-default"
                  : "cursor-pointer"
              }`}
              onClick={() => {
                if (item?.statusDetails?.title === "Draft") {
                  setIsModalOpen((prev) => ({
                    ...prev,
                    reminder: true,
                    data: item,
                  }));
                }
              }}
            >
              Send Reminder{" "}
            </span>
          ),
        },
        ...(item?.chatDetails?._id || permission?.details
          ? [
              {
                _id: 12,
                type: "action",
                align: "left",
                cellClass: "w-[5%]",
                actionData: [
                  ...(permission?.details && status === "ok"
                    ? [
                        {
                          _id: 1,
                          name: "View Submission",
                          icon: "fa-regular fa-eye",
                          onClick: () =>
                            navigate(
                              `/admin/scholarship-application/list/view-submittion?scholarshipId=${item?._id}`
                            ),
                          standout: false,
                        },
                      ]
                    : []),
                  ...(item?.chatDetails?._id
                    ? [
                        {
                          _id: 2,
                          name: "Go to communication",
                          icon: "fa-regular fa-messages",
                          onClick: () => {
                            const params = {
                              chatId: item?.chatDetails?._id,
                              recipientId: item?.chatDetails?.userId,
                              scholarshipId: item?.scholarshipId,
                              senderId: session?.user?._id,
                            };
                            window.open(
                              `/admin/communications?id=${btoa(
                                encodeId(params)
                              )}`,
                              "_blank"
                            );
                          },
                          standout: false,
                        },
                      ]
                    : []),
                  ...(permission?.delete && status === "ok"
                    ? [
                        {
                          _id: 3,
                          name: "Delete",
                          icon: "fa-regular fa-trash-can",
                          standout: true,
                          onClick: () => {
                            setDeleteModal({
                              isOpen: true,
                              data: item,
                            });
                          },
                        },
                      ]
                    : []),
                ],
              },
            ]
          : []),
      ],
    };
  });

  const {
    mutate: getApplicationDetails,
    isPending: applicationDetailsPending,
  } = useMutation({
    mutationFn: async ({ application, chatCreateRes }) => {
      const res = await scholarshipApplicationDetails({ id: application?._id });
      return { res, application };
    },
    onSuccess: ({ res, application }) => {
      if (res?.status === 200) {
        updateData((pre) => {
          pre.data = pre?.data?.map((item, i) =>
            item?._id === application?._id
              ? { ...item, chatDetails: res?.data?.chatDetails }
              : item
          );
          return { ...pre };
        });
      }
    },
    onError: (err) => {},
  });

  const { mutate: chatCreateHandler, isPending: chatCreatePending } =
    useMutation({
      mutationFn: async (val) => {
        const res = await creatChatList({
          userId: val?.userId,
          scholarshipId: val?.scholarshipId,
        });
        return { res, val };
      },
      onSuccess: ({ res, val }) => {
        if (res?.status === 200) {
          getApplicationDetails({ application: val, chatCreateRes: res });
          setModalOpen({
            isOpen: true,
            data: { ...val, chatId: res?.data?._id },
          });
        }
      },
      onError: (err) => {},
    });

  function sendMessageResponse(res) {
    // if (res?.status === 200) {
    //   setModalOpen({ isOpen: false, data: null });
    // } else {
    //   toast.warning(res?.message);
    // }
  }

  function scholarshipStatusResponse(res) {
    if (res.status >= 200 && res.status < 300) {
      console.log({ res });

      updateData((pre) => ({
        ...pre,
        data: pre?.data?.map((item) =>
          item?._id === res?.data?._id ? res?.data : item
        ),
        metadata: {
          ...pre.metadata,
          extraCount: {
            ...pre.metadata.extraCount,
            draftApplication:
              res?.data?.statusDetails?.title === "Draft"
                ? pre.metadata.extraCount.draftApplication + 1
                : pre.metadata.extraCount.draftApplication - 1,
          },
        },
      }));
      setModalOpen({ isOpen: false, data: null });
    } else {
      toast.warning(res?.message);
    }
  }

  const { mutate: deletefunction, isPending: deletePending } = useMutation({
    mutationFn: async (payload) => {
      const res = await scholarshipAppDelete({
        ids: Array.isArray(payload) ? payload : [payload],
      });
      return {
        res,
        payload: Array.isArray(payload) ? payload : [payload],
      };
    },
    onSuccess: ({ res, payload }) => {
      if (res?.status === 200) {
        setDeleteModal({ isOpen: false, data: null });
        updateData((pre) => {
          pre.data = (pre?.data || [])?.filter(
            (item) => !payload?.includes(item?._id)
          );
          return { ...pre };
        });
        if (data?.metadata?.totalDocs > filters?.limit) {
          refetch();
        }
      } else {
        toast.warning(res?.message || res?.error);
      }
    },
    onError: (error) => {
      console.log(error);
    },
  });

  return (
    <div className="space-y-4 w-full flex flex-col pb-10">
      <div className="space-y-8">
        <div className="font-bold text-center text-lg xl:text-3xl text-chestnut-rose">
          Scholarship Application
        </div>

        <div className="flex items-center gap-3">
          <div className="w-36">
            <LimitSelect
              value={filters?.limit}
              allValue={data?.metadata?.totalDocs}
              onChange={(val) => handleFilterChange("limit", val, setFilters)}
            />
          </div>
          <div className="w-72">
            <Search
              placeholder={"Search here"}
              search={(val) => {
                setKeyword(val);
                handleFilterChange("page", 1, setFilters);
              }}
            />
          </div>
          <div className="ml-auto space-x-3">
            <span className="text-chestnut-rose font-CanelaDeck">
              Total : {data?.metadata?.totalDocs || 0}
            </span>
            <span className="text-chestnut-rose font-CanelaDeck">
              Draft : {data?.metadata?.extraCount?.draftApplication || 0}
            </span>
          </div>
        </div>
      </div>
      {status === "ok" &&
        (permission?.list ? (
          <Table
            tableHeadData={tableHeadData}
            tableData={tableData}
            isLoder={isLoading}
            pageCount={data?.metadata?.totalPages}
            currentPage={filters?.page}
            onPageChange={(val) => {
              handleFilterChange("page", val, setFilters);
              setSelectedItems([]);
            }}
            isFetching={isFetching}
            isOrderingDisabled={true}
            selectedItems={selectedItems}
            setSelectedItems={setSelectedItems}
            tableActionDropdownContainer={"!w-48"}
          />
        ) : (
          <div className="font-semibold text-xl text-center h-60 flex items-center justify-center text-shades-07">
            You don't have permission to view this list.
          </div>
        ))}
      <ScholarshipMessageModal
        open={modalOpen?.isOpen}
        data={modalOpen?.data}
        close={() => setModalOpen({ isOpen: false, data: null })}
        getResponse={sendMessageResponse}
      />
      <ScholarshipStatusModal
        open={statusModalOpen?.isOpen}
        data={statusModalOpen?.data}
        close={() => setStatusModalOpen({ isOpen: false, data: null })}
        getResponse={scholarshipStatusResponse}
      />
      <ReminderModal
        open={isModelOpen.reminder}
        data={isModelOpen?.data}
        close={() =>
          setIsModalOpen((prev) => ({ ...prev, reminder: false, data: null }))
        }
      />
      {chatCreatePending && (
        <div className="bg-black/70 w-full h-full fixed top-0 left-0 z-100 !m-0 text-white flex flex-col items-center justify-center text-2xl font-semibold">
          <div className="w-36 h-36 overflow-hidden">
            <Lottie animationData={createAnimation} loop={true} size={10} />
          </div>
          Please wait we are creating the chat...
        </div>
      )}
      <DeleteModal
        open={deleteModal?.isOpen}
        loading={deletePending}
        onClose={() => setDeleteModal((pre) => ({ ...pre, isOpen: false }))}
        deleteHandler={() => deletefunction([deleteModal?.data?._id])}
      />
    </div>
  );
};

export default ScholarshipView;
